/*eslint-disable */
import Healthcheck from './Health'
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import { fetchHealthCheck, getHealthCheckError, getHealthCheckStatus, selectHealthCheck } from '../../store/reducers/healthCheckSlice'
import LoadingSpinner from '../../components/loadingSpinner'
import styles from './Health.module.scss'

function ServerStatusIndicator({ status, healthCheck, t }) {
  if (status === 'loading' || status === 'idle') {
    return (
      <div className={styles.serverStatus}>
        <span className={`${styles.statusDot} ${styles.gray}`} />
        <span className={styles.statusText}>{t('health-loading-status')}</span>
      </div>
    )
  }

  let statusColor = 'gray'
  let statusText = t('health-status-false')

  if (healthCheck.status === true) {
    statusColor = 'green'
    statusText = t('health-status-true')
  } else if (healthCheck.status === false) {
    statusColor = 'red'
    statusText = t('health-status-issues')
  }

  return (
    <div className={styles.serverStatus}>
      <span className={`${styles.statusDot} ${styles[statusColor]}`} />
      <span className={styles.statusText}>{statusText}</span>
    </div>
  )
}

ServerStatusIndicator.propTypes = {
  status: PropTypes.string.isRequired,
  healthCheck: PropTypes.shape({}).isRequired,
  t: PropTypes.func.isRequired
}

export function Health() {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const healthCheck = useSelector(selectHealthCheck)
  const status = useSelector(getHealthCheckStatus)
  const error = useSelector(getHealthCheckError)
  useEffect(() => {
    dispatch(fetchHealthCheck())
  }, [dispatch])

  let content
  if (status === 'loading' || status === 'idle') {
    content = (
      <div className={styles.loadingContainer} style={{ marginBottom: '150px', display: 'flex', alignItems: 'center' }}>
        <LoadingSpinner />
      </div>
    )
  } else if (status === 'failed') {
    content = <p>Error: {error}</p>
  } else {
    content = (
      <table className={styles.healthTable}>
        <tbody>
          <tr className={styles.alternateRow}>
            <th className={styles.headerCell}>{t('health-status-title')}</th>
            <td className={styles.cell}>{healthCheck.status ? t('health-status-healthy') : t('health-status-unhealthy')}</td>
          </tr>
          <tr className={styles.row}>
            <th className={styles.headerCell}>{t('health-uptime-title')}</th>
            <td className={styles.cell}>{healthCheck.uptime}</td>
          </tr>
          <tr className={styles.alternateRow}>
            <th className={styles.headerCell}>{t('health-idp-title')}</th>
            <td className={styles.cell}>{healthCheck.idpStatus.health === 'active' ? t('Active') : t('Inactive')}</td>
          </tr>
        </tbody>
      </table>
    )
  }

  return (
    <div>
        <Healthcheck
          t={t}
          status={status}
          healthCheck={healthCheck}
          error={error}
          ServerStatusIndicator={ServerStatusIndicator}
          content={content}
        />
    </div>
  )
}

export default Health